var _rect, _rect2, _rect3, _rect4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentationCharacteristicOutlinedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 11,
    viewBox: "0 0 18 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "stroke-background",
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 10,
    rx: 1.5,
    stroke: "#000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "stroke-background",
    x: 2.5,
    y: 4.5,
    width: 2,
    height: 2,
    rx: 1,
    stroke: "#000"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "stroke-background",
    x: 6.5,
    y: 4.5,
    width: 5,
    height: 2,
    rx: 1,
    stroke: "#000"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "stroke-background",
    x: 13.5,
    y: 4.5,
    width: 2,
    height: 2,
    rx: 1,
    stroke: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentationCharacteristicOutlinedIcon);
export default __webpack_public_path__ + "static/media/documentationCharacteristicOutlinedIcon.e1ada88a.svg";
export { ForwardRef as ReactComponent };